<template lang="html">
  <div>
    <p>{{ recipes.length }} recipes</p>
    <pre>{{ recipes }}</pre>
  </div>
</template>

<script>
  import recipes from '../../static/recipes.json'
  export default {
    data() {
      return {
        recipes
      }
    },
    methods: {
      
    },
    mounted() {
      // console.log(this.recipes.filter(function(obj) { return obj.post_content.indexOf('http') == -1 }))
      // this.recipes.forEach(function(element) {
      //   delete element.post_author
      //   delete element.post_excerpt
      //   delete element.post_status
      //   delete element.comment_status
      //   delete element.ping_status
      //   delete element.post_password
      //   delete element.to_ping
      //   delete element.pinged
      //   delete element.post_content_filtered
      //   delete element.post_parent
      //   delete element.guid
      //   delete element.menu_order
      //   delete element.post_type
      //   delete element.comment_count
      //   delete element.post_mime_type
      //   delete element.post_date_gmt
      //   delete element.post_modified
      //   delete element.post_modified_gmt
      // })
      // console.log(this.recipes)
      // this.recipes.forEach(function(element) {
      //   element.category = "main"
      // })
      // console.log(this.recipes)
    }
  }
</script>

<style lang="css">
</style>
